import { render, staticRenderFns } from "./CustomDialogHeaderComponent.vue?vue&type=template&id=44ef6188&scoped=true&lang=pug"
import script from "./CustomDialogHeaderComponent.vue?vue&type=script&lang=ts"
export * from "./CustomDialogHeaderComponent.vue?vue&type=script&lang=ts"
import style0 from "./CustomDialogHeaderComponent.vue?vue&type=style&index=0&id=44ef6188&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ef6188",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44ef6188')) {
      api.createRecord('44ef6188', component.options)
    } else {
      api.reload('44ef6188', component.options)
    }
    module.hot.accept("./CustomDialogHeaderComponent.vue?vue&type=template&id=44ef6188&scoped=true&lang=pug", function () {
      api.rerender('44ef6188', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Dialog/CustomDialog/CustomDialogHeaderComponent.vue"
export default component.exports